import Headroom from 'headroom.js';

class ShapesMenu {
	paths = [
		'var( --clip-path-triangle )',
		'var( --clip-path-circle )',
		'var( --clip-path-square )',
	];

	constructor( node ) {
		this.node = node;
		this.canvas = this.node.querySelector( '.shapes-menu__canvas' );
		this.interval = null;
		this.index = -1;
		this.duration = 1000;

		this.node.addEventListener( 'pointerenter', this.start.bind( this ) );
		this.node.addEventListener( 'pointerleave', this.reset.bind( this ) );
	}

	start() {
		this.next();
		this.interval = window.setInterval( this.next.bind( this ), this.duration );
	}

	next() {
		if ( ! this.paths[ this.index + 1 ] ) {
			return this.reset();
		}

		this.index++;
		this.canvas.style.clipPath = this.paths[ this.index ];
	}

	reset() {
		if ( typeof this.interval === 'number' ) {
			clearInterval( this.interval );
			this.interval = null;
			this.index = -1;
		}

		this.canvas.style.clipPath = '';
	}
}

function onMenuClick( e ) {
	e.preventDefault();
	e.target.dispatchEvent( new CustomEvent( 'global-nav:menu', { bubbles: true } ) );
}

function onSearchClick( e ) {
	e.preventDefault();

	if ( document.body.classList.contains( 'search' ) ) {
		const advancedSearchInput = document.querySelector( '.coveo-advanced-query__input' );

		if ( advancedSearchInput ) {
			advancedSearchInput.focus();
			return;
		}
	}

	e.target.dispatchEvent( new CustomEvent( 'global-nav:search', { bubbles: true } ) );
}

function onLinkClick( e ) {
	if ( this.hash ) {
		e.preventDefault();

		this.dispatchEvent(
			new CustomEvent( 'global-nav:activate', {
				bubbles: true,
				detail: {
					hash: this.hash,
					event: e,
				},
			} )
		);
	}
}

export function init() {
	const header = document.querySelector( '.wp-block-template-part--header' );
	const node = document.querySelector( '.masthead' );

	for ( const menu of node.querySelectorAll( '.masthead__action--menu' ) ) {
		menu.addEventListener( 'click', onMenuClick );
	}

	for ( const search of node.querySelectorAll( '.masthead__action--search' ) ) {
		// search.addEventListener( 'click', onSearchClick );
	}

	for ( const link of node.querySelectorAll( '.masthead__link' ) ) {
		link.addEventListener( 'click', onLinkClick );
	}

	// headroom sticky hide configuration - @see https://www.npmjs.com/package/headroom.js
	const headroom = new Headroom( header, {
		tolerance: {
			up: 7,
			down: 5,
		},
	} );

	headroom.init();
	headroom.update( headroom );

	new ShapesMenu( document.querySelector( '.shapes-menu' ) );
}

if (
	[
		'ready',
		'interactive',
	].includes( document.readyState )
) {
	init();
} else {
	document.addEventListener( 'DOMContentLoaded', init );
}
